import React, { useState } from "react";
import { ContentFormHome, ContentFormService, ContentFormClinic, ContentFormAbout, ContentFormProcedure, ContentFormPortfolio, ContentFormContact, ContentFormBlog,ContentFormSecondAbout,ContentFormBeforeAfter,ContentFormDentalStore } from "../../SecondComponents";

const SecondDesignContentForm = () => {
    const [path, setPath] = useState('Home')
    return (
        <div>
            {path === 'Home' ? (
                <ContentFormHome path={path} setPath={setPath}/>
            ) : path === 'About' ? (
                <ContentFormAbout path={path} setPath={setPath} />
            ) : path === 'About Page 2' ? (
                <ContentFormSecondAbout path={path} setPath={setPath} />
            ) : path === 'Before After' ? (
                <ContentFormBeforeAfter path={path} setPath={setPath} />
            ) : path === 'Dental Store' ? (
                <ContentFormDentalStore path={path} setPath={setPath} />
            ) : path === 'Services' ? (
                <ContentFormService path={path} setPath={setPath} />
            ) : path === 'Procedure' ? (
                <ContentFormProcedure path={path} setPath={setPath} />
            ) : (
                <ContentFormPortfolio path={path} setPath={setPath} />
            )}
        </div>
    )
}

export default SecondDesignContentForm